import React, {useState, useRef, useEffect} from "react";
import {GeolocationControl, Map, Placemark, YMaps} from "react-yandex-maps";

export default function OrderMap({useDefaultLocation = false, events}) {

    const thisMap = useRef(null);
    const [mapInstance, setMapInstance] = useState(null);
    const [coordinates, setCoordinates] = useState([]);

    const mapData = {
        center: [53.356920, 83.710743],
        zoom: 13,
    };

    useEffect(() => {

        if (mapInstance) {
            commonLoadParams(mapInstance);
        }

        if (mapInstance || thisMap.current) {
            onEvent(thisMap.current);
        }

    }, [mapInstance, thisMap.current !== undefined]);

    const commonLoadParams = ymaps => {
        return ymaps.geolocation.get({provider: "browser", mapStateAutoApply: true}).then(result => ymaps.geocode(result.geoObjects.position).then(res => {
                let current_geo_coordinates = res.geoObjects.get(0).geometry.getCoordinates();

                if (useDefaultLocation) {
                    setPlacemark(current_geo_coordinates);
                    getAddress(current_geo_coordinates).then((address) => {
                        if (events.onClickMap) {
                            events.onClickMap(address);
                        }
                    });
                    thisMap.current.setCenter(current_geo_coordinates);
                    thisMap.current.setZoom(15);
                }
            })
        );
    };

    let onEvent = (instance) => {
        if (instance) {
            instance.events.add('click', onClickMap);
        }
    };

    let setPlacemark = (coords) => {
        let mark = new mapInstance.Placemark(coords, {}, {});
        thisMap.current.geoObjects.add(mark);
    };

    let onClickMap = (e) => {
        thisMap.current.geoObjects.each((el, index) => {
            thisMap.current.geoObjects.remove(el);
        });
        let coords = e.get('coords');


        setPlacemark(coords);
        getAddress(coords).then((address) => {
            if (events.onClickMap) {
                events.onClickMap(address);
            }
        });
    };

    let getAddress = (coords) => {
        return mapInstance.geocode(coords).then(function (res) {
            let firstGeoObject = res.geoObjects.get(0);

            return firstGeoObject.getAddressLine().replace(/Алтайский край,/g, '');
        });
    };

    return <YMaps query={{apikey: '6ff29c21-740b-42c8-b626-81e1097f38fb'}}>
        <Map
            style={{width: '100%', height: '400px'}}
            instanceRef={(ref) => {
                if (ref) {
                    thisMap.current = ref;
                }
            }}
            modules={["Placemark", 'geolocation', "geocode", "geoObject.addon.balloon"]}
            onLoad={inst => setMapInstance(inst)}
            defaultState={mapData}
        >


            {coordinates.map((coordinate, idx) => <Placemark key={idx} geometry={coordinate}/>)}
            <GeolocationControl options={{float: 'left'}}/>


        </Map>
    </YMaps>;
}